<template>
	<div>
		<div class="main-accounting">
				<h3 class="py-3 px-4 font-weight-bold accounting-headline">
					Definición de Asientos
					<!--<v-tooltip top>
						<v-btn dark icon slot="activator"
							@click="openModal">
							<v-icon>add</v-icon>
						</v-btn>
						<span>Contabilización de Auxiliares</span>
					</v-tooltip> !-->
				</h3>
			<template>
				<v-layout wrap align-center mx-4 py-3 class="accounting-container">
					<v-flex flex xs2 pl-1>
						<label class="caption">Definición:</label>
					</v-flex>
					<v-flex flex  xs4 pl-1 py-2 mb-3 >
						<BaseSelect
							label="Módulo"
							item-text="name"
							item-value="id"
							:height="38"
							:items="modules"
							v-model="model.moduleId"
							@input="setData($event)"
						>
							<span slot="error" class="caption error--text" v-if="$v.model.moduleId.$invalid">
								El módulo es requerido
							</span>
						</BaseSelect>
					</v-flex>
					<v-flex flex  xs6>
						<div class="accouting-Aux">
							<v-dialog
								v-model="openConfirmationModal"
								width="80%"
							>
								<v-card height="100%" class="CardSeat">
									<v-card-title  class="titleCard">
										<img src="https://japi-static.s3.amazonaws.com/undefined/logo-maki-open.png" height="29">
										<v-btn
											class="btnCloseDialog"
											@click="openConfirmationModal = false"
											icon
											>
											<v-icon class="iconClose" color="white">highlight_off</v-icon>
										</v-btn>
									</v-card-title>
									<v-card-text >
									<v-layout row wrap>
										<v-flex xs12 class="title-heading pt-1">
											Revision Auxiliares - Libros Contables
										</v-flex>
										<v-flex xs12 mx-5 class="body-select pt-1" text-xs-center>
											<div class="option-body">
											<label class="label-option">Contabilización General</label>
											<v-checkbox
												class="ma-0 justify-center check-table"
												color="success"
												hide-details
											></v-checkbox>
											<label class="label-option">Contabilización Diaria
											</label>
											<v-checkbox
												class="ma-0 justify-center check-table"
												color="success"
												hide-details
											></v-checkbox>
											<label class="label-option">Contabilizacion por Documento
											</label>
											<v-checkbox
												class="ma-0 justify-center check-table"
												color="success"
												hide-details
											></v-checkbox>
											</div>
										</v-flex>
										<v-flex xs5 pl-1 mx-5 pa-3  class="body-selected pt-1">
											<BaseSelect
												label="Fuente"
												item-text="name"
												item-value="id"
												:height="38"
												:items="modules"
												v-model="model.moduleId"
												@input="setData($event)"
											>
												<span slot="error" class="caption error--text" v-if="$v.model.moduleId.$invalid">
													El módulo es requerido
												</span>
											</BaseSelect>
										</v-flex>
										<v-flex xs5  mx-5 pa-3 class="body-selected pt-1">
											<BaseSelect
												label="Definición"
												item-text="name"
												item-value="id"
												:height="38"
												:items="modules"
												v-model="model.moduleId"
												@input="setData($event)"
											>
												<span slot="error" class="caption error--text" v-if="$v.model.moduleId.$invalid">
													El módulo es requerido
												</span>
											</BaseSelect>
										</v-flex>
									</v-layout>
									<v-layout row wrap>
										<v-flex xs12 class="title-heading pt-1">
											Integración
										</v-flex>
										<v-flex xs12 class="body-seat-form">
											<v-layout row wrap align-end py-2>
												<v-flex xs4>
													<app-input-text
														model="gloss"
														:id="modules.length === 0 || modules.length === 1 ? 'focus-new-seat' : ''"
														placeholder="Condición"
														:tabindex="modules.length === 0 || modules.length === 1 ? 1 : 2"
														:text="model.gloss"
													></app-input-text>
												</v-flex>
												<v-flex xs2 pl-2>
													<date-component
														:date="model.date"
														icon="/static/img/calendar.svg"
														placeholder="Desde"
														:tabindex="modules.length === 0 || modules.length === 1 ? 2 : 3"
													></date-component>
												</v-flex>
												<v-flex xs2 pl-2>
													<date-component
														:date="model.date"
														icon="/static/img/calendar.svg"
														placeholder="Hasta"
														:tabindex="modules.length === 0 || modules.length === 1 ? 2 : 3"
													></date-component>
												</v-flex>
												<v-flex xs4 pl-2 text-xs-center>
													<v-btn
														small
														class="btn-action"
														color="cyan"
														:disabled="$v.$invalid || disabled"
														@click="$emit('save', rows)"
													>
														Filtrar
														<v-icon icon>funnel-minus</v-icon>
													</v-btn>
												</v-flex>
											</v-layout>
										</v-flex>
									</v-layout>
										<v-layout row wrap>
										<v-flex xs12 class="title-heading pt-1">
											Contabilización Automatica Por Lotes
										</v-flex>
										<v-layout row wrap align-end py-2>
										<v-flex xs3 mx-3>
													<app-input-text
														model="gloss"
														:id="modules.length === 0 || modules.length === 1 ? 'focus-new-seat' : ''"
														placeholder="Asiento"
														:tabindex="modules.length === 0 || modules.length === 1 ? 1 : 2"
														:text="model.gloss"
													></app-input-text>
												</v-flex>
											<v-flex xs3 mx-3>
													<app-input-text
														model="gloss"
														:id="modules.length === 0 || modules.length === 1 ? 'focus-new-seat' : ''"
														placeholder="Referencia"
														:tabindex="modules.length === 0 || modules.length === 1 ? 1 : 2"
														:text="model.gloss"
													></app-input-text>
												</v-flex>
												<v-flex xs3 mx-3>
													<app-input-text
														model="gloss"
														:id="modules.length === 0 || modules.length === 1 ? 'focus-new-seat' : ''"
														placeholder="Descripción"
														:tabindex="modules.length === 0 || modules.length === 1 ? 1 : 2"
														:text="model.gloss"
													></app-input-text>
												</v-flex>
												<v-flex xs2 pl-2>
													<date-component
														:date="model.date"
														icon="/static/img/calendar.svg"
														placeholder="Fecha"
														:tabindex="modules.length === 0 || modules.length === 1 ? 2 : 3"
													></date-component>
												</v-flex>
										</v-layout>
										<v-flex xs12 py-2 class="body-seat-form">
											<v-layout row wrap align-end>
												<app-table
													class="mt-1 is-not-selectable"
													name="listSeating"
													:current-page="currentPage"
													:last-page="lastPage"
													:columns="columns"
													:rows="rows"
												>
													<template slot="rows" slot-scope="props">
														<td v-show="showRow(columns, 1)" class="date">
															<template v-if="editDetailInline">
																<autocomplete-component
																	append-icon="expand_more"
																	class="edit-inline"
																	http-code="$http"
																	id="focus-edit-inline"
																	:item="props.row.accountingAccount"
																	item-text="fullName"
																	item-value="id"
																	:items="accounts"
																	autocomplete
																	model="accountingAccount"
																	placeholder-value="Buscar cuenta contable"
																	placeholder-input="Nombre de la cuenta"
																	prop="account"
																	prop-search="fullName"
																	:resource-url="`accounting-plan/${subsidiaryId}/subsidiary`"
																	return-object
																	select-create
																	tabindex="1"
																	@return-data="$emit('get-data', { model: 'accountingAccount', value: $event, row: props.row })"
																></autocomplete-component>
															</template>
															<template v-else>
																<div class="text-account text-absolute">
																	<span>{{ props.row.accountingAccount }}</span>
																</div>
															</template>
														</td>
														<td v-show="showRow(columns, 2)" class="name">
															<template v-if="editDetailInline">
																<app-input-text
																	class="edit-inline"
																	model="description"
																	tabindex="2"
																	:text="props.row.description"
																	@input="setDataDetail({row: props.row, model:  $event.model, value: $event.value })"
																></app-input-text>
																</template>
																<template v-else>
																	{{ props.row.description }}
																</template>
														</td>
														<td v-show="showRow(columns, 3)" class="ruc">
																<template v-if="editDetailInline">
																	<app-input-text
																		class="edit-inline"
																		model="concept"
																		tabindex="2"
																		:text="props.row.concept"
																		@input="setDataDetail({row: props.row, model:  $event.model, value: $event.value })"
																	></app-input-text>
																</template>
																<template v-else>
																	{{ props.row.concept }}
																</template>

														</td>
														<td v-show="showRow(columns, 4)" class="ruc">
																<template v-if="editDetailInline">
																	<app-input-text
																		class="edit-inline"
																		model="terms"
																		tabindex="2"
																		:text="props.row.terms"
																		@input="setDataDetail({row: props.row, model:  $event.model, value: $event.value })"
																	></app-input-text>
																</template>
																<template v-else>
																	{{ props.row.terms }}
																</template>
														</td>
														<td v-show="showRow(columns, 5)" class="ruc">
															<template v-if="editDetailInline">
																<app-input-text
																	class="edit-inline"
																	model="formula"
																	tabindex="2"
																	:text="props.row.formula"
																	@input="setDataDetail({row: props.row, model:  $event.model, value: $event.value })"
																></app-input-text>
															</template>
															<template v-else>
																{{ props.row.formula }}
															</template>
														</td>
														<td v-show="showRow(columns, 6)" class="ruc">
															<template v-if="editDetailInline">
																<app-input-text
																	class="edit-inline"
																	model="reference"
																	tabindex="2"
																	:text="props.row.reference"
																	@input="setDataDetail({row: props.row, model:  $event.model, value: $event.value })"
																></app-input-text>
															</template>
															<template v-else>
																{{ props.row.reference }}
															</template>
														</td>
														<td v-show="showRow(columns, 7)" @click.stop="stopClick" class="actions">
															<template v-if="editDetailInline">
																<button
																	class="btn-edit-detail"
																	type="button"
																	tabindex="6"
																	@click="inlineEditDetail(props.row)"
																>
																	Guardar
																</button>
															</template>
															<template v-else>
																<app-tooltip-button
																	class="no-movil"
																	color="success"
																	img="/static/img/actions-list/edit.svg"
																	text="Editar Registro Contable"
																	:width="18"
																	@click-icon="editLine(props.row)"
																/>
																<app-tooltip-button
																	class="no-movil"
																	img="/static/img/actions-list/delete.svg"
																	text="Eliminar Registro Contable"
																	:width="18"
																	@click-icon="deleteDetail(props.row)"
																/>
																<div
																	class="collapse-menu"
																>
																	<v-menu>
																		<v-btn dark icon slot="activator">
																			<v-icon>more_horiz</v-icon>
																		</v-btn>
																		<v-list>
																			<v-list-tile class="btn-menu-content">
																				<v-list-tile-title class="menu-content">
																					<img
																						src="/static/img/icons/edit.svg"
																						alt="icono"
																						class="menu-option-icon"
																						width="15px"
																						height="15px"
																					>
																					<span class="ml-1 edit">Editar Registro Contable</span>
																				</v-list-tile-title>
																			</v-list-tile>
																			<v-list-tile>
																				<v-list-tile-title class="menu-content">
																					<img
																						src="/static/img/actions-list/delete.svg"
																						alt="icono"
																						class="menu-option-icon"
																						width="15px"
																						height="15px"
																					>
																					<span class="ml-1">Eliminar Registro Contable</span>
																				</v-list-tile-title>
																			</v-list-tile>
																		</v-list>
																	</v-menu>
																</div>
															</template>
														</td>
													</template>
												</app-table>
											</v-layout>
										</v-flex>
										<v-layout xs12 py-2 pa-3 text-xs-center>
												<v-flex xs3  pl-3 mx-5>
													<div class="content-blue  height-input px-2">
														<span class="debitV">DEBE:</span>
													</div>
												</v-flex>
												<v-flex xs3 pl-3 mx-5>
													<div class="content-red  height-input px-2">
															<span class="debitC">HABER:</span>
													</div>
												</v-flex>
												<v-flex xs3 pl-3 mx-5>
													<div class="content-gray  height-input px-2">
														<span class="debitB"> SALDO:</span>
													</div>
												</v-flex>
										</v-layout>
									</v-layout>
									</v-card-text>
								</v-card>
							</v-dialog>
						</div>
					</v-flex>
				<!--<v-flex flex content-semi-green xs12 pl-9 py-3 mb-4>
						<label class="caption"  >Encabezado de Registro Contable</label>
					</v-flex>
					<v-flex flex  xs2 pl-3 py-3 mb-4>
						<label class="caption"  >Referencia de Registro</label>
					</v-flex>
					<v-flex flex  xs3 pl-3 py-3 mb-4>

						<BaseInput
							:height="38"
							label="Referencia de Registro"
						/>
					</v-flex>
					<v-flex flex  xs2 pl-3 py-3 mb-4>
						<label class="caption"  >Descripción de Registro</label>
					</v-flex>
					<v-flex flex  xs3 pl-3 py-3 mb-4>
						<BaseInput
							:height="38"
							label="Descriṕción de Registro"
						/>
					</v-flex> -->
					<v-flex flex content-semi-green xs12 pl-9 py-3 mb-4>
						<label class="caption"  >Lista de registros contables</label>
					</v-flex>
					<v-flex  xs12 pl-9 py-3 mb-4>
							<app-table
								class="mt-1 is-not-selectable"
								name="listSeating"
								:current-page="currentPage"
								:last-page="lastPage"
								:columns="columns"
								:rows="rows"
							>
								<template slot="rows" slot-scope="props">
									<td v-show="showRow(columns, 1)" class="date">
										<template v-if="editDetailInline">
												<app-input-text
													class="edit-inline"
													model="description"
													tabindex="2"
													:text="props.row.description"
													@input="setDataDetail({row: props.row, model:  $event.model, value: $event.value })"
												></app-input-text>
											</template>
										<template v-else>
											<div class="text-account text-absolute">
												<span>{{ props.row.description }}</span>
											</div>
										</template>
									</td>
									<td v-show="showRow(columns, 2)" class="name">
										<template v-if="editDetailInline">
											<autocomplete-component
												append-icon="expand_more"
												class="edit-inline"
												http-code="$http"
												id="focus-edit-inline"
												:item="props.row.accountingAccount"
												item-text="fullName"
												item-value="id"
												:items="accounts"
												autocomplete
												model="accountingAccount"
												placeholder-value="Buscar cuenta contable"
												placeholder-input="Nombre de la cuenta"
												prop="account"
												prop-search="fullName"
												:resource-url="`accounting-plan/${subsidiaryId}/subsidiary`"
												return-object
												select-create
												tabindex="1"
												@return-data="$emit('get-data', { model: 'accountingAccount', value: $event, row: props.row })"
												></autocomplete-component>
										</template>
											<template v-else>
												{{ props.row.accountingAccount }}
											</template>
									</td>
									<td v-show="showRow(columns, 3)" class="ruc">
										<template v-if="editDetailInline">
											<app-input-text
												class="edit-inline"
												model="reference"
												tabindex="2"
												:text="props.row.reference"
												@input="setDataDetail({row: props.row, model:  $event.model, value: $event.value })"
											></app-input-text>
										</template>
											<template v-else>
												{{ props.row.reference }}
											</template>

									</td>
									<td v-show="showRow(columns, 4)" class="ruc">
										<template v-if="editDetailInline">
											<app-input-text
												class="edit-inline"
												model="concept"
												tabindex="2"
												:text="props.row.concept"
												@input="setDataDetail({row: props.row, model:  $event.model, value: $event.value })"
											></app-input-text>
										</template>
											<template v-else>
												{{ props.row.concept }}
											</template>
									</td>
									<td v-show="showRow(columns, 5)" class="ruc">
										<template v-if="editDetailInline">
											<app-input-text
												class="edit-inline"
												model="formula"
												tabindex="2"
												:text="props.row.formula"
												@input="setDataDetail({row: props.row, model:  $event.model, value: $event.value })"
											></app-input-text>
										</template>
										<template v-else>
											{{ props.row.formula }}
										</template>
									</td>
									<td v-show="showRow(columns, 6)" class="ruc">
										<template v-if="editDetailInline">
											<app-input-text
												class="edit-inline"
												model="terms"
												tabindex="2"
												:text="props.row.terms"
												@input="setDataDetail({row: props.row, model:  $event.model, value: $event.value })"
											></app-input-text>
										</template>
										<template v-else>
											{{ props.row.terms }}
										</template>
									</td>
									<td v-show="showRow(columns, 7)" @click.stop="stopClick" class="actions">
										<template v-if="editDetailInline">
											<button
												class="btn-edit-detail"
												type="button"
												tabindex="6"
												@click="inlineEditDetail(props.row)"
											>
												Guardar
											</button>
										</template>
										<template v-else>
											<app-tooltip-button
												class="no-movil"
												color="success"
												img="/static/img/actions-list/edit.svg"
												text="Editar Registro Contable"
												:width="18"
												@click-icon="editLine(props.row)"
											/>
											<app-tooltip-button
												class="no-movil"
												img="/static/img/actions-list/delete.svg"
												text="Eliminar Registro Contable"
												:width="18"
												@click-icon="deleteDetail(props.row)"
											/>
											<div
												class="collapse-menu"
											>
												<v-menu>
													<v-btn dark icon slot="activator">
														<v-icon>more_horiz</v-icon>
													</v-btn>
													<v-list>
														<v-list-tile class="btn-menu-content">
															<v-list-tile-title class="menu-content">
																<img
																	src="/static/img/icons/edit.svg"
																	alt="icono"
																	class="menu-option-icon"
																	width="15px"
																	height="15px"
																>
																<span class="ml-1 edit">Editar Registro Contable</span>
															</v-list-tile-title>
														</v-list-tile>
														<v-list-tile>
															<v-list-tile-title class="menu-content">
																<img
																	src="/static/img/actions-list/delete.svg"
																	alt="icono"
																	class="menu-option-icon"
																	width="15px"
																	height="15px"
																>
																<span class="ml-1">Eliminar Registro Contable</span>
															</v-list-tile-title>
														</v-list-tile>
													</v-list>
												</v-menu>
											</div>
										</template>
									</td>
								</template>
							</app-table>
					</v-flex>
				</v-layout>
			</template>
			<v-layout wrap align-center justify-center class="save-container">
				<v-flex text-xs-center>
					<v-btn
						small
						class="btn-action"
						color="cyan"
						:disabled="disabled"
						@click="$emit('save', rows)"
					>
						Guardar
					</v-btn>
				</v-flex>
			</v-layout>
		</div>
	</div>
</template>

<script>
	import appInputText from '@/components/autocomplete/app-input-text';
	import { minValue, required } from 'vuelidate/lib/validators';
	import appTooltipButton from '@/components/shared/app-tooltip-button';
	import autocompleteComponent from '@/components/autocomplete/autocomplete-component';
	import dateComponent from '@/components/autocomplete/date-component';

	async function mounted() {
		this.loadResources();
	}
	function created() {
		this.loadAccounts();
	}
	function setData(val) {
		this.loadRecords(val);
	}
	function openModal() {
		this.openConfirmationModal = true;
	}

	function editLine(row) {
		this.editDetailInline = true;
		this.modelDetail = { ...row };
	}
	function allowVisualizeName({ allowVisualize }) {
		return allowVisualize ? 'Sí' : 'No';
	}
	function setDataDetail({ model, value }) {
		this.modelDetail[model] = value;
		if (model === 'accountingAccount') {
			this.modelDetail.account = value.code;
			this.modelDetail.accountingAccountId = value.id;
		}
	}
	async function loadAccounts() {
		const subsidiaryId = this.$route.query.subsidiaryId || this.currentSubsidiary.id;
		const params = {
			status: 1,
		};
		({ data: this.accounts } = await this.$http.get(
			`accounting-plan/${subsidiaryId}/subsidiary`, { params }));
	}

	async function inlineEditDetail({ id }) {
		const body = {
			accountingAccount: this.modelDetail.accountingAccount,
			code: this.modelDetail.code,
			description: this.modelDetail.description,
			reference: this.modelDetail.reference,
			concept: this.modelDetail.concept,
			terms: this.modelDetail.terms,
			formula: this.modelDetail.formula,
		};
		try {
			await this.$http.patch(`rules/${id}`, body);
			this.showNotification('La regla ha sido editada correctamente.');
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		} finally {
			this.editDetailInline = false;
		}
	}
	async function deleteDetail({ id }) {
		try {
			await this.$http.delete(`rules/${id}`);
			this.showNotification('La regla ha sido eliminada correctamente.');
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		} finally {
			this.editDetailInline = false;
		}
	}
	async function loadResources() {
		const subsidiaryId = this.$route.query.subsidiaryId || this.currentSubsidiary.id;
		const request = [
			this.$http.get('type-register', { params: { subsidiaryId } }),
		];
		[{ data: this.modules }] = await Promise.all(request);
	}
	function automaticAccountingName({ automaticAccounting }) {
		return automaticAccounting ? 'Sí' : 'No';
	}
	function validations() {
		return {
			model: {
				moduleId: { minValue: minValue(1), required },
			},
		};
	}
	async function loadRecords(id) {
		try {
			const { data: modules } = await this.$http.get(
				`rules-by-module/${id}`);
			this.rows = modules;
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		}
	}
	function data() {
		return {
			modules: [],
			model: {
				moduleId: null,
			},
			columns: [
				{ id: 1, name: 'Regla', value: 'accountingAccount', checked: true, visible: true },
				{ id: 2, name: 'Cuenta Contable', value: 'description', checked: true, visible: true },
				{ id: 3, name: 'Referencia', value: 'concept', checked: true, visible: true },
				{ id: 4, name: 'Concepto', value: 'terms', checked: true, visible: true },
				{ id: 5, name: 'Formúla', value: 'formula', checked: true, visible: true },
				{ id: 6, name: 'Condición', value: 'reference', checked: true, visible: true },
				{ id: 7, name: 'Acciones', checked: true, visible: true, flagVisible: true },
			],
			modelDetail: {
				accountingAccount: null,
				description: null,
				concept: '',
				reference: '',
				terms: '',
				formula: null,
				accounts: [],
			},
			currentPage: 1,
			lastPage: 1,
			rows: [],
			editDetailInline: false,
			openConfirmationModal: false,
		};
	}

	export default {
		name: 'accounting-parametrization-seating',
		mounted,
		created,
		components: {
			BaseSelect: () => import('@/components/shared/inputs/base-select'),
			BaseInput: () => import('@/components/shared/inputs/base-input'),
			appTooltipButton,
			appInputText,
			autocompleteComponent,
			dateComponent,
		},
		data,
		methods: {
			allowVisualizeName,
			automaticAccountingName,
			loadResources,
			loadRecords,
			loadAccounts,
			setData,
			inlineEditDetail,
			setDataDetail,
			editLine,
			deleteDetail,
			openModal,
		},
		props: {
			disabled: {
				default: false,
				type: Boolean,
			},
		},
		validations,
	};
</script>

<style lang="scss" scoped>
	.main-accounting {
		background-color: white;
		border-radius: 20px;
		font-family: font(AvenirRegular);
		font-size: size(medium);
	}
	.accounting-container {
		border-bottom: 1px solid color(grey-background-filter);
	}

	.accounting-name {
		font-family: font(AvenirDemi);
	}

	.save-container {
		background-color: white;
		bottom: 0;
		height: 68px;
		left: 0;
		position: fixed;
		width: 100%;
	}
	.caption {
		font-family: font(AvenirRegular);
		font-size: size(medium);
		font-weight: 700;
	}
	.accounting-headline {
		background-color: PowderBlue !important;
		border-top-left-radius: 20px;
		border-top-right-radius: 20px;
		@include flex-between;
	}
	.content-semi-green {
		background-color: #e0f3f3;
		color: #4a4a4a;
		font-family: Opens_regular;
		@include flex-center;
		.caption {
			font-size: 15px !important;
			font-weight: 900 !important;
		}
	}
	.btn-edit-detail {
		background-color: color(secondary);
		border-radius: 10px;
		color: color(white);
		font-family: font(AvenirBold);
		font-size: size(small11);
		padding: 2px 4px 0px;
	}
	.collapse-menu {
		display: none;
		@media (max-width: 780px) {
			align-items: center;
			display: block;
			height: 100%;
			justify-content: center;
		}

		.v-menu {
		align-items: center;
		display: flex;
		height: 100%;
		justify-content: center;

		.v-btn {
			background-color: color(btn-green);
			height: 25px;
			margin: 0;
			width: 25px;
		}
	}
}

	.menu-content {
		align-items: center;
		color: color(red-icon);
		display: grid;
		font-family: font(AvenirRegular);
		font-size: size(small) !important;
		grid-column-gap: 3px;
		grid-template-columns: 15px 1fr;
		width: 175px;

		.factory {
			color: color(secondary);
		}

		.edit {
			color: color(btn-green);
		}
	}

	.btn-menu-content {
		border-bottom: 1px solid color(grey-background-table);
	}
	.v-btn {
		background-color: color(blue-icon);
		height: 25px;
		margin: 0;
		width: 25px;
	}
	.accouting-Aux {
		@include flex-end;
	}
	.CardSeat {
		border-radius: 13px;
		.titleCard {
			background-color: #03A89E !important;
			@include flex-between;
			.btnCloseDialog {
				margin: 0;
				background-color:red;
				height:20px;
				width:20px;
			}
		}
		.title-heading {
			background-color: #e0f3f3;
			color: color(black);
			font-family: font(AvenirRegular);
			font-size: size(small);
			font-weight: 700;
			height: 25px;
			text-align: center;
		}
		.option-body {
			@include flex-center;
			.label-option {
				font-family: font(AvenirRegular);
				font-size: size(small);
			}
		}
		.body-selected {
			color: color(black);
			font-family: font(AvenirRegular);
			font-size: size(medium);
			height: 85px;
		}
		.content-blue {
		opacity:0.4;
		background-color: #02979b ;
		color: map-get($colors, secondary);
			.debitV {
				width: 174px;
				height: 20px;
				font-family: font(AvenirRegular);
				font-size: 16px;
				font-weight: 700;
				font-stretch: normal;
				font-style: normal;
				line-height: 1.54;
				letter-spacing: normal;
				text-align: center;
				color: white;
			}
		}
		.content-red {
			opacity:0.4;
			background-color: #f22d20;
			color: map-get($colors, red-icon);
			.debitC {
				width: 174px;
				height: 20px;
				font-family: monospace;
				font-size: 16px;
				font-weight: 500;
				font-stretch: normal;
				font-style: normal;
				line-height: 1.54;
				letter-spacing: normal;
				text-align: center;
				color: white;
			}
		}

	.content-gray {
		opacity:0.4;
		background-color: #696cff;
		color: map-get($colors, white);
		.debitB {
			width: 174px;
			height: 20px;
			font-family: monospace;
			font-size: 16px;
			font-weight: 500;
			font-stretch: normal;
			font-style: normal;
			line-height: 1.54;
			letter-spacing: normal;
			text-align: center;
			color: white;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/accounting-parametrizations/accounting-parametrization-seating.vue